import { fromJS } from 'immutable';
import {
  SPELL_CHECK_SUCCEED,
  SPELL_CHECK_FAILED,
  SPELL_CHECK_REMOVE_SPELLING,
} from './constants';

export const initialState = fromJS([]);

function spellCheckReducer(state = initialState, action) {
  switch (action.type) {
    case SPELL_CHECK_SUCCEED:
      return action.payload.key
        ? state
        : fromJS(action.payload.data.map(spelling => ({
          word: spelling.word,
          suggestions: spelling.s,
          column: spelling.col,
          row: spelling.row,
          wordLength: spelling.len,
          mistakeCode: spelling.code,
        })));

    case SPELL_CHECK_FAILED:
      return action.payload.key
        ? state
        : initialState;

    case SPELL_CHECK_REMOVE_SPELLING:
      return state.filterNot(spelling => spelling.get('word') === action.payload.word);

    default:
      return state;
  }
}

export default spellCheckReducer;
